<template>
  <div :class="$style.wrapper">
    <div :class="$style.right"><vue-hacker-text text="PROGRAMM V.1.12" speed="medium"/></div>
    <div :class="$style.left">
      <div v-for="number in stageNumber" :key="number">
        <vue-hacker-text v-if="number === currentStageNumber" :text="`SC_REEN ${currentStageNumber} / ${stageNumber}`" speed="fast"/>
      </div>
    </div>
    <div :class="$style.center"><vue-hacker-text text="LOADING 100%" speed="fast"/></div>
  </div>
</template>
<script>
export default {
  name: 'labels',
  props: {
    stageNumber: Number,
    currentStageNumber: Number,
  },
}
</script>
<style lang="scss" module>
.wrapper {
  color: #000;
  pointer-events: none;
  @include vtFont;
  font-size: 1.4rem;

  & > div {
    position: fixed;
  }
}
.right {
  top: env(safe-area-inset-top, 0);
  right: env(safe-area-inset-right, 0);
  margin-right: 2rem;
  margin-top: 2rem;
}
.left {
  bottom: env(safe-area-inset-bottom, 0);
  left: env(safe-area-inset-left, 0);
  margin-left: 2rem;
  margin-bottom: 2rem;
}
.center {
  bottom: env(safe-area-inset-bottom, 0);
  margin-bottom: 2rem;
  left: 50%;
  transform: translate(-50%, 0);
}
</style>
